import { Component } from "react";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import FooterFixedOnScreen from "../Layout/FooterFixedOnScreen";
import GoogleDriveIcon from "../../images/google-drive-icon.png";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DetailsTab from "../../components/ComponentsPark/Found/DetailsTab";
import WorkOrdersTab from "../../components/ComponentsPark/Found/WorkOrdersTab";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { clearComponentsSearch } from "../../redux/componentsPark/componentsParkActions";
import { connect } from "react-redux";
import "./ComponentFound.css";
import { withRouter } from "react-router";

const styles = (theme) => ({
    card: {
        minWidth: 100,
        marginBottom: "85px",
    },
    textField: {
        width: "100%",
        margin: theme.spacing(1),
    },
    textField_50: {
        width: "45%",
        margin: theme.spacing(1),
    },
    table: {
        tableLayout: "auto",
        width: "100%",
    },
    tableCell: {
        padding: "8px 8px 8px 8px",
    },
});

function TabContainer({ children, dir }) {
    return (
        <Typography component="div" dir={dir}>
            {children}
        </Typography>
    );
}

class ComponentPark extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
        };

        if (!this.props.componentPark) this.props.history.push("/parks");
    }

    handleChange = (event, value) => {
        this.setState({ selectedTab: value });
    };

    handleChangeIndex = (index) => {
        this.setState({ selectedTab: index });
    };

    handleClearComponentsSearch() {
        this.props.clearComponentsSearch();
    }

    openDriveLink() {
        var win = window.open(this.props.componentPark.google_drive_url, "_blank");
        win.focus();
    }

    render() {
        if (!this.props.componentPark) return <div></div>;

        let googleDriveBtnElement = <div></div>;
        if (this.props.componentPark.google_drive_url && !this.props.isExtranetApp) {
            googleDriveBtnElement = (
                <div className="offset-lg-8 col-lg-2 offset-md-8 col-md-2 offset-sm-4 col-sm-4 offset-4 col-4 center">
                    <Fab onClick={this.openDriveLink.bind(this)} className="div-center">
                        <img src={GoogleDriveIcon} alt="" width="32px" height="32px" />
                    </Fab>
                    <span className="floating-btn-text span-center">Drive</span>
                </div>
            );
        }

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding component-found-margin container-with-footer">
                    <AppBar position="static" color="default">
                        <Tabs
                            value={this.state.selectedTab}
                            onChange={this.handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                        >
                            <Tab label="Détails" />
                            <Tab label="Interventions" />
                        </Tabs>
                    </AppBar>
                    <SwipeableViews axis="x" index={this.state.selectedTab} onChangeIndex={this.handleChangeIndex}>
                        <TabContainer>
                            <DetailsTab />
                        </TabContainer>
                        <TabContainer className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <WorkOrdersTab />
                        </TabContainer>
                    </SwipeableViews>
                </div>
                <FooterFixedOnScreen>
                    <div className="row">
                        {this.props.blockOtherScan ? (
                            <div className="col-lg-2 col-md-2 col-sm-4 col-4"></div>
                        ) : (
                            <div className="col-lg-2 col-md-2 col-sm-4 col-4">
                                <Fab
                                    onClick={this.handleClearComponentsSearch.bind(this)}
                                    color="primary"
                                    className="div-center"
                                >
                                    <Icon>arrow_back</Icon>
                                </Fab>
                                <span className="floating-btn-text span-center">Autre scan</span>
                            </div>
                        )}
                        {googleDriveBtnElement}
                    </div>
                </FooterFixedOnScreen>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        componentPark: state.componentsPark.currentComponent,
        isExtranetApp: state.context.isExtranetApp,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearComponentsSearch: () => dispatch(clearComponentsSearch()),
    };
};

export default compose(withRouter, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(ComponentPark);
